module.exports = __webpack_public_path__ + "static/media/NimbusSanL-BolIta.f73d1ab7.woff";